//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    imageUrl: String,
    caption: String,
    widthPercent: {
      type: Number,
      default: 100
    }
  }
}
